import React from "react"
import styled from "styled-components"

import { minWidth, maxWidth, when } from "utils"

import SectionHeading from "components/section-heading"
import TextBlock from "components/text-block"

export const Container = styled.div`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};
  padding: 2rem 0;
  color: ${({ theme }) => theme.component.text};
  background-color: ${({ theme }) => theme.component.background};
`

export const Heading = styled(SectionHeading)`
  padding: 0 2rem;

  ${minWidth.tablet`
    padding: 0;
  `}
`

export const TableWrapper = styled.div``

export const TableText = styled(TextBlock)`
  width: 100%;
  padding-top: 0;
  padding-bottom: 4rem;

  ${when("fullWidth")`
    padding-left: 2rem;
    padding-right: 2rem;
  `}

  ${maxWidth.mobile`
    ${when("lockFirstColumnOnMobile")`
      overflow-x: auto;

      table {
        width: unset;
      }
    `}
  `}

  ${when("dataHasHeaderRow")`
    thead {
      tr {
        th {
          padding: 2rem;
          border: 0 !important;
          text-align: ${({ align }) => align.header || "left"};
          color: ${({ rowColors }) => rowColors.header.text};
          background-color: ${({ rowColors }) => rowColors.header.background};

          &:first-child {
            ${({ align }) =>
              align.firstColumn &&
              `
                text-align: ${align.firstColumn};
              `}

            ${when("lockFirstColumnOnMobile")`
              position: sticky;
              left: 0;
            `}
          }

          &:last-child {
            ${({ align }) =>
              align.lastColumn &&
              `
                text-align: ${align.lastColumn};
              `}
          }
        }
      }
    }
  `}

  tbody {
    tr {
      &:nth-child(even) {
        td {
          color: ${({ rowColors }) => rowColors.even.text};
          background-color: ${({ rowColors }) => rowColors.even.background};

          div[class*="checkmark-yes"] {
            background-color: ${({ rowColors }) => rowColors.even.highlight};
          }
          div[class*="checkmark-no"] {
            border-color: ${({ rowColors }) => rowColors.even.highlight};
          }
        }
      }

      &:nth-child(odd) {
        td {
          color: ${({ rowColors }) => rowColors.odd.text};
          background-color: ${({ rowColors }) => rowColors.odd.background};

          div[class*="checkmark-yes"] {
            background-color: ${({ rowColors }) => rowColors.odd.highlight};
          }
          div[class*="checkmark-no"] {
            border-color: ${({ rowColors }) => rowColors.odd.highlight};
          }
        }
      }

      td {
        padding: 2rem;
        border: 0 !important;
        text-align: ${({ align }) => align.cell || "left"};

        &:first-child {
          ${({ align }) =>
            align.firstColumn &&
            `
              text-align: ${align.firstColumn};
            `}

          ${when("lockFirstColumnOnMobile")`
            position: sticky;
            left: 0;
            z-index: 1;
          `}
        }

        &:last-child {
          ${({ align }) =>
            align.lastColumn &&
            `
              text-align: ${align.lastColumn};
            `}
        }
      }
    }
  }
`

export const FullCircle = styled.div`
  display: inline-block;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  transform: rotate(45deg);
`

export const Check = styled.div`
  position: absolute;
  top: 0.4rem;
  left: 1.1rem;
  width: 0.2rem;
  height: 1.2rem;
  background-color: #fff;
`

export const CheckKick = styled.div`
  position: absolute;
  top: 1.3rem;
  left: 0.8rem;
  width: 0.3rem;
  height: 0.3rem;
  background-color: #fff;
`

export const EmptyCircle = styled.div`
  display: inline-block;
  width: 2.2rem;
  height: 2.2rem;
  border-width: 0.2rem;
  border-style: solid;
  border-radius: 50%;
`

export const CheckmarkYes = () => (
  <FullCircle className="checkmark-yes">
    <Check />
    <CheckKick />
  </FullCircle>
)

export const CheckmarkNo = () => <EmptyCircle className="checkmark-no" />
